const VIEWER_COLOR_PALETTE = [
	"#d97085",
	"#52b788",
	"#f4d06f",
	"#5b9bd5",
	"#e09f60",
	"#9b72b0",
	"#59c3b8",
	"#c9726a",
	"#a8b5b8",
	"#4d9b8d",
	"#d68860",
	"#536878",
	"#e5b563",
	"#b36a60",
	"#8a9498"
];

export function generateViewerColorPalette(count: number): string[] {
	if (count <= VIEWER_COLOR_PALETTE.length) {
		return VIEWER_COLOR_PALETTE.slice(0, count);
	}

	const generatedColors = [...VIEWER_COLOR_PALETTE];
	for (let i = VIEWER_COLOR_PALETTE.length; i < count; i++) {
		const hue = (i * 137.508) % 360;
		const saturation = 65 + ((i * 23) % 30);
		const lightness = 55 + ((i * 17) % 25);
		generatedColors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
	}

	return generatedColors;
}

export function getViewerColorFromId(id: string): string {
	let hash = 0;
	for (let i = 0; i < id.length; i++) {
		hash = ((hash << 5) - hash) + id.charCodeAt(i);
		hash = hash & hash;
	}
	const colorIndex = Math.abs(hash) % VIEWER_COLOR_PALETTE.length;
	return VIEWER_COLOR_PALETTE[colorIndex];
}
